<template>
  <ion-page>
    <ion-header>
      <ion-toolbar class="topbar">
        <ion-buttons slot="start">
          <button class="close-btn" type="button" aria-label="关闭" @click="onClose">
            <ion-icon class="close-icon" :icon="chevronBackOutline"></ion-icon>
          </button>
        </ion-buttons>
        <ion-title>{{ isVideo ? "视频" : "图片" }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="media-wrap">
        <video
          v-if="isVideo"
          class="media-video"
          :src="imageUrl"
          controls
          playsinline
          autoplay
        ></video>
        <img v-else class="media-image" :src="imageUrl" alt="" />
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonIcon,
  modalController,
} from "@ionic/vue"

import { chevronBackOutline } from "ionicons/icons"

export default {
  name: "AttachmentImage",
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonIcon,
  },
  props: {
    imageUrl: {
      type: String,
      default: "",
    },
    mediaType: {
      type: String,
      default: "image",
    },
  },

  setup() {
    return {
      chevronBackOutline,
    }
  },

  computed: {
    isVideo() {
      if (this.mediaType === "video") return true
      const url = String(this.imageUrl || "").toLowerCase()
      return /\.(mp4|webm|mov|m4v|avi|mkv)(\?|$)/.test(url)
    },
  },

  mounted() {
    this.userinfo = this.store.getCurrentUser?.() || null
  },

  methods: {
    onClose() {
      modalController.dismiss()
    },
  },
}
</script>
<style scoped>
.close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0.6rem 0.85rem;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  color: #fff;
}

.close-btn ion-icon,
.close-btn .close-icon {
  font-size: 1.5rem;
  color: #fff;
  pointer-events: none;
}

.close-btn .close-icon::part(icon),
.close-btn ion-icon::part(icon) {
  color: #fff;
  fill: #fff;
  stroke: #fff;
}

.topbar {
  --background: #000;
  --color: #fff;
  --border-width: 0;
}

.media-wrap {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
}

.media-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.media-video {
  width: 100%;
  max-height: 100%;
  background: #000;
}
</style>
